const features = [
    {
        id: 1,
        title: 'Increase brand awareness',
        content: 'Leverage our network of 5M+ users to promote your brand and products through highly-targeted product sampling campaigns. Peekage amplifies your outreach efforts by connecting your brand to a highly engaged user segment.',
        image: 'new/customer-experience-digital-product-sampling.jpg',
        imageAlt: 'Improve customer experience digital product sampling',
        class: '',
        aos: {
            content: 'fade-in',
            image: 'fade-in',
        },
        component: 'FeatureItem',
    },
    {
        id: 2,
        title: 'Get in front of the right shoppers',
        content: "Target consumers who fit your buyer's persona by using over 200+ filtering attributes, ranging from preferences for natural or organic products to specific dietary restrictions and shopping habits, and everything in between. Unsure about your perfect audience? Create multiple segments and conduct A/B tests through Peekage’s quick product testing services to identify your ideal customers and pinpoint their attributes.",
        image: 'insights/increase-retail-sales-product-sampling-services.jpg',
        imageAlt: 'Increase retail sales with Peekage product sampling services',
        component: 'FeatureItem',
        class: 'nth-reverse',
        aos: {
            content: 'fade-in',
            image: 'fade-in',
        },
    },
    {
        id: 3,
        title: 'Amplify Your Brand’s Voice with Peekage’s Vibrant Community',
        headline: 'Diverse Community of Shoppers',
        content: 'Peekage has built a community of vibrant, highly engaged natural shoppers who join Peekage to test and review new products and discover their new favorite products. They share insights into their shopping habits, dietary preferences, interests, routines, and more with you. Matched shoppers provide reviews, share their experiences on social media with friends, and even visit stores to purchase your product. With their active participation, they help to increase awareness, generating word-of-mouth recommendations and boosting sales for your products.',
        image: 'insights/peekage-consumer-panels.jpg',
        imageAlt: 'Peekage: Consumer panels',
        component: 'FeatureItem',
        class: '',
        aos: {
            content: 'fade-in',
            image: 'fade-in',
        },
        url: '/natural-shoppers-community',
        buttonTitle: 'Meet our community',
        isSpecialButton: true,
    },
    {
        id: 4,
        title: 'Create Social Proof for Success',
        content: 'Unlock the potential of social proof to elevate your brand and drive success both online and in retail. Generate thousands of authentic, high-quality product reviews and social media content from vetted, natural shoppers quickly. Effortlessly syndicate user generated content across all your product listings, from your website to retailer platforms where potential consumers browse. With Peekage, launch viral review programs that resonate with engaged consumers eager to test and review new products.',
        image: 'community/consumer-community.png',
        imageAlt: 'Consumer community',
        component: 'FeatureItem',
        class: 'nth-reverse',
        aos: {
            content: 'fade-in',
            image: 'fade-in',
        },
    },
    {
        id: 5,
        title: 'Collect real-time consumer feedback',
        content: "Maximize the Return on Investment (ROI) from your sampling campaigns with Peekage's real-time consumer feedback capture. We conduct expert-designed surveys and gather feedback both before and after trials from customers who have experienced your product. Our advanced consumer insights engine processes all collected data to unveil actionable insights regarding your campaign, products, marketing strategies, product positioning, messaging, and more.",
        image: 'insights/building-trust-product-testing-reviews.jpg',
        imageAlt: 'Building trust with product testing reviews',
        component: 'FeatureItem',
        class: '',
        aos: {
            content: 'fade-in',
            image: 'fade-in',
        },
    },
    {
        id: 6,
        title: 'Grow your email subscriber lists',
        content: 'Boost your omnichannel conversion rate and enhance customer retention by growing your email list with high-quality leads who have shown interest in your brand and tested your products. With Peekage, 100% of users subscribe to your marketing emails after each sampling campaign, allowing you to rapidly grow your email list.',
        image: 'new/email-subscribers-peekage-digital-product-sampling.jpg',
        imageAlt: 'Increase email subscribers with Peekage\'s digital product sampling',
        component: 'FeatureItem',
        class: 'nth-reverse',
        aos: {
            content: 'fade-in',
            image: 'fade-in',
        },
    },
];

export default features;
